module.exports = __webpack_public_path__ + "img/07_shimizu_09.56b70922.jpg";